export default {
  init() {
    show_and_hide_year_devider();
    fallbackImageWhenImageNotFound();
  },
};

export var show_and_hide_year_devider = () => {
  $('.orders-year-devider').click(function () {
    let parent = $(this).parent();
    parent.find('.product-order').each(function () {
      if ($(this).is(':hidden')) {
        $(this).show();
      } else if ($(this).is(':visible')) {
        $(this).hide();
      }
    });
  });
}

export var fallbackImageWhenImageNotFound = () => {
  const imgTags = $('img.order-image');
  imgTags.on('error', function() {
    if (!$(this).attr('src').includes('/404.jpg')) {
      $(this).attr('src', 'https://old.wolkyimages.com/404.jpg');
    }
  });
}
